export default __webpack_public_path__ + "static/media/peter_choong.ba159523.jpg";